import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Descarga Inmediata',
  text: 'Recibes el manual PDF en tu email en menos de 2 minutos. Discreto, privado, sin preguntas incómodas.'
}, {
  num: '2',
  title: 'Aplica la Secuencia de 3 Pasos',
  text: 'Sigues el protocolo exacto. Sin adivinar. Sin improvisar. Solo sigue las instrucciones al pie de la letra.'
}, {
  num: '3',
  title: 'Recupera el Control',
  text: 'En menos de una semana, la mayoría de los hombres reporta no solo firmeza, sino una confianza mental renovada.'
}];
export function HowItWorksSection() {
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-131">
            3 Pasos Simples. Sin Complicaciones. Sin Esperas.
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-132"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-133">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-slate-800 z-0" data-id="element-134"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="relative z-10 flex flex-col items-center text-center bg-slate-950 p-8 rounded-3xl border border-slate-800" data-id="element-135">
              <div className="w-16 h-16 rounded-full bg-slate-900 border-2 border-blue-500 flex items-center justify-center text-2xl font-bold text-blue-400 mb-6 shadow-[0_0_15px_rgba(37,99,235,0.3)]" data-id="element-136">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-137">
                {step.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-138">{step.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}